@if(!discountInputAdded()) {
<button mat-icon-button color="primary" type="button" [matMenuTriggerFor]="discountMenu">
  <mat-icon>sell</mat-icon>
</button>
} @else {
<button mat-icon-button color="warn" type="button" (click)="removeDiscountControl.emit()">
  <mat-icon>money_off</mat-icon>
</button>
}

<mat-menu #discountMenu="matMenu">
  <button mat-menu-item type="button" (click)="onDiscountSelect(DiscountType.PERCENT)">
    <mat-icon>percent</mat-icon>
    <span>{{
      'charges-table.discount-menu.percentage-discount' | translate
    }}</span>
  </button>
  <button mat-menu-item type="button" (click)="onDiscountSelect(DiscountType.FIXED)">
    <mat-icon>money_off</mat-icon>
    <span>{{
      'charges-table.discount-menu.fixed-amount-discount' | translate
    }}</span>
  </button>
</mat-menu>
